<template>
  <div class="check-password-container">
    <div class="line">
      <VIcon :name="pwValidCheckLength? checkmarkCircle : ellipse" :connotation="pwValidCheckLength ? 'success' : undefined" :class="pwValidCheckLength ? 'successIcon' : 'default'"></VIcon>
      <span class="vtext-body marginLeft">12 characters minimum</span>
    </div>
    <div class="line">
      <VIcon :name="pwValidCheckCapitalChar? checkmarkCircle : ellipse" :connotation="pwValidCheckCapitalChar ? 'success' : undefined" :class="pwValidCheckCapitalChar ? 'successIcon' : 'default'"></VIcon>
      <span class="vtext-body marginLeft">1 capital case</span>
    </div>
    <div class="line">
      <VIcon :name="pwValidCheckSmallChar? checkmarkCircle : ellipse" :connotation="pwValidCheckSmallChar ? 'success' : undefined" :class="pwValidCheckSmallChar ? 'successIcon' : 'default'"></VIcon>
      <span class="vtext-body marginLeft">1 small case</span>
    </div>
    <div class="line">
      <VIcon :name="pwValidCheckNumber? checkmarkCircle : ellipse" :connotation="pwValidCheckNumber ? 'success' : undefined" :class="pwValidCheckNumber ? 'successIcon' : 'default'"></VIcon>
      <span class="vtext-body marginLeft">1 numeric</span>
    </div>
    <div class="line">
      <VIcon :name="pwValidCheckSpecialChar? checkmarkCircle : ellipse" :connotation="pwValidCheckSpecialChar ? 'success' : undefined" :class="pwValidCheckSpecialChar ? 'successIcon' : 'default'"></VIcon>
      <span class="vtext-body marginLeft">1 special character</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    password: {
      type: String
    }
  },
  emits: ['validated'],
  data() {
    return {
      checkmarkCircle: 'check-circle-line', ellipse: 'check-circle-solid',
      pwValidCheckLength: false,
      pwValidCheckSmallChar: false,
      pwValidCheckCapitalChar: false,
      pwValidCheckNumber: false,
      pwValidCheckSpecialChar: false,
    }
  },
  watch: {
    password(){
      this.passwordValidationChecks();
    },
  },
  methods: {
    passwordValidationChecks(passwordMinLength = 12) {
      const password = this.password;

      // Early return if password is empty/undefined/null
      if (!password) {
        this.pwValidCheckLength = false;
        this.pwValidCheckSmallChar = false;
        this.pwValidCheckCapitalChar = false;
        this.pwValidCheckNumber = false;
        this.pwValidCheckSpecialChar = false;
        this.$emit('validated', false);
        return;
      }

      this.pwValidCheckLength = password.length >= passwordMinLength;
      this.pwValidCheckSmallChar = /[a-z]/.test(password);
      this.pwValidCheckCapitalChar = /[A-Z]/.test(password);
      this.pwValidCheckNumber = /\d/.test(password);
      this.pwValidCheckSpecialChar = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/.test(password);

      if (!this.pwValidCheckLength || !this.pwValidCheckSmallChar || !this.pwValidCheckCapitalChar || !this.pwValidCheckNumber || !this.pwValidCheckSpecialChar) this.$emit('validated', false);
      else this.$emit('validated', true);
    },
  }
}
</script>

<style lang="scss" scoped src="@/resources/css/settings.scss"> </style>
<style lang="scss" scoped>
.check-password-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 10px;
  .line {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
  }
}
</style>